import type { Icon } from '../../../appComponents/LinkIcon.tsx'

export interface Link {
  title: string
  url: string
  type: Icon
}

// ___Why not just an array, why a function that returns an array?
//    Because it lets us refresh the whole UI without refreshing the page!
function getLinks(linksFor?: 'user' | 'admin' | 'founder', workspace?: string) {
  const user: Link[] = [
    {
      title: 'Dashboard',
      url: `/c/${workspace}`,
      type: 'dashboard',
    },
    {
      title: 'Assemblies',
      url: `/c/${workspace}/assemblies`,
      type: 'assemblies',
    },
    {
      title: 'Templates',
      url: `/c/${workspace}/templates`,
      type: 'templates',
    },
    {
      title: 'Credentials',
      url: `/c/${workspace}/template-credentials`,
      type: 'credentials',
    },
    {
      title: 'Collaborators',
      url: `/c/${workspace}/collaborators`,
      type: 'collaborators',
    },
    {
      title: 'Settings',
      url: `/c/${workspace}/settings`,
      type: 'settings',
    },
    {
      title: 'Addons',
      url: `/c/${workspace}/addons`,
      type: 'addons',
    },
    {
      title: 'Billing & Plan',
      url: `/c/${workspace}/billing`,
      type: 'billing',
    },
  ]

  const admin: Link[] = [
    {
      title: 'Dashboard',
      url: `/c/admin/dashboard`,
      type: 'admin-dashboard',
    },
    {
      title: 'All Assemblies',
      url: '/c/admin/assemblies',
      type: 'admin-assemblies',
    },
    {
      title: 'Workspaces',
      url: '/c/admin/workspaces',
      type: 'admin-workspaces',
    },
    {
      title: 'Coupons',
      url: '/c/admin/coupons',
      type: 'admin-coupons',
    },
    {
      title: 'Ops',
      url: `/c/admin/ops`,
      type: 'admin-ops',
    },
    {
      title: 'Announcements',
      url: `/c/admin/announcements`,
      type: 'admin-announcements',
    },
  ]

  const founder: Link[] = [
    {
      title: 'Dashboard',
      url: '/c/admin/founder-dashboard/',
      type: 'founder-dashboard',
    },
    {
      title: 'All Invoices',
      url: '/c/admin/invoices',
      type: 'founder-invoices',
    },
    {
      title: 'Revenue Changes',
      url: '/c/admin/revenues/',
      type: 'founder-revenues',
    },
    {
      title: 'Plans',
      url: '/c/admin/plans',
      type: 'founder-plans',
    },
  ]

  switch (linksFor) {
    case 'user':
      return user
    case 'admin':
      return admin
    case 'founder':
      return founder
    default:
      return [...user, ...admin, ...founder]
  }
}

export default getLinks
